import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CompanyService } from '../../service/data/company.service';
import { BrfMortgagePrescription } from '../../model/brf-mortgage-prescription';
import { BrfMortgagePrescriptionService } from '../../service/data/brf-mortgage-prescription.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';


@Component({
    selector: 'app-brf-mortgage-prescription-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BrfMortgagePrescriptionManagerComponent extends PagedObjectManagerComponent<BrfMortgagePrescription> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: BrfMortgagePrescriptionService,
    private _companyService: CompanyService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    factory: ColumnDefinitionFactory,
    messageService: MessageService,
    navigationService: NavigationService,
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getMortgagePrescriptionColumnDefinition();
    this.title = 'COOPERATIVE_HOUSING.MORTGAGE_PRESCRIPTIONS';
    this.preferencesKey = 'rent.brf-mortgage-prescription.list';
    this.allowNew = false;
    this.allowOpenOnRowClick = false;
    this.showExcelExportButton = true;
    this.excelFileName = 'Pantforskrivningar'; // TODO: translate dynamically
    this.excelContext = 'BrfMortgagePrescriptions';
    this.createExcelColumnDefinitions(factory);
  }

  private createExcelColumnDefinitions(factory: ColumnDefinitionFactory) {
    this.excelColumnDefinition = [...this.columnDefinition];
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.companyId,
            this._companyService,
            definition.selectedFields.includes('companyId')
          ),     
        ];
      })
    );
  }
}
